/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import { getAxiosConnection } from '../api';
import { LOCAL_STORAGE_KEYS } from './constants';
import getQuery from './query';

const axiosConnection = getAxiosConnection();

export const cacheUserToken = (access_token) => {
  // eslint-disable-next-line no-undef
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_ACCESS_TOKEN, access_token);
  axiosConnection.defaults.headers.common.authorization = `${access_token}`;
};

export const cachePartialFlowToken = (access_token) => {
  // eslint-disable-next-line no-undef
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_ACCESS_TOKEN_PARTIAL_LOGIN, access_token);
  axiosConnection.defaults.headers.common.authorization = `${access_token}`;
};

export const cacheUserFirstUsage = () => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.FIRST_USAGE, true);
};

export const cacheUserFirstAccess = () => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.FIRST_ACCESS, true);
};

export const cacheHiddenUserCurrencyList = (currency_list = []) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_HIDDEN_CURRENCY_LIST, JSON.stringify(currency_list));
};

export const cacheUserEnvironment = (env) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_ENVIRONMENT, env);
};

export const cacheUserBannerInfo = () => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_BANNER, false);
};

export const hideCryptodraftBannerInfo = () => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_CRYPTODRAFT_BANNER, false);
};

export const getCryptodraftBannerInfo = () =>
  localStorage.getItem(LOCAL_STORAGE_KEYS.SHOW_CRYPTODRAFT_BANNER);

export const cacheShowCardHint = (isShowing) => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_CARD_HINT, isShowing);
};

export const cacheUserWantsToStayInUSApp = () => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_WANTS_TO_STAY_IN_US_APP, 'true');
};

export const cacheUserWantsToStayInInternationalApp = () => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_WANTS_TO_STAY_IN_INTERNATIONAL_APP, 'true');
};

export const getCacheUserWantsToStayInUSApp = () =>
  localStorage.getItem(LOCAL_STORAGE_KEYS.USER_WANTS_TO_STAY_IN_US_APP);

export const getCacheUserWantsToStayInInternationalApp = () =>
  localStorage.getItem(LOCAL_STORAGE_KEYS.USER_WANTS_TO_STAY_IN_INTERNATIONAL_APP);

export const getCachedHiddenUserCurrencyList = () =>
  JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.USER_HIDDEN_CURRENCY_LIST)) || [];

export const getUserBannerInfo = () => localStorage.getItem(LOCAL_STORAGE_KEYS.SHOW_BANNER);

export const getShowCardHint = () => localStorage.getItem(LOCAL_STORAGE_KEYS.SHOW_CARD_HINT);

export const resetUserSession = () => {
  if (getUserBannerInfo() === 'false' && getCryptodraftBannerInfo() === 'false') {
    localStorage.clear();
    localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_BANNER, false);
    localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_CRYPTODRAFT_BANNER, false);
  } else if (getCryptodraftBannerInfo() === 'false') {
    localStorage.clear();
    localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_CRYPTODRAFT_BANNER, false);
  } else if (getUserBannerInfo() === 'false') {
    localStorage.clear();
    localStorage.setItem(LOCAL_STORAGE_KEYS.SHOW_BANNER, false);
  } else {
    localStorage.clear();
  }
  delete axiosConnection.defaults.headers.common.authorization;
  const queryClient = getQuery();
  queryClient.removeQueries();
};

export const getCachedUserToken = () => localStorage.getItem(LOCAL_STORAGE_KEYS.USER_ACCESS_TOKEN);

export const removeCachedPartialFlowToken = () =>
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ACCESS_TOKEN_PARTIAL_LOGIN);

export const getCacheUserFirstUsage = () => localStorage.getItem(LOCAL_STORAGE_KEYS.FIRST_USAGE);

export const getCacheUserFirstAccess = () => localStorage.getItem(LOCAL_STORAGE_KEYS.FIRST_ACCESS);

export const getUserEnvironment = () => localStorage.getItem(LOCAL_STORAGE_KEYS.USER_ENVIRONMENT);

export const clearUserEnvironment = () =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_ENVIRONMENT, '');

export const cacheRecaptchaV3failure = () => {
  localStorage.setItem(LOCAL_STORAGE_KEYS.RECAPTCHA_V3_FAILURE, 'true');
};

export const getCacheRecaptchaV3failure = () =>
  localStorage.getItem(LOCAL_STORAGE_KEYS.RECAPTCHA_V3_FAILURE);

export const clearRecaptchaV3failure = () =>
  localStorage.setItem(LOCAL_STORAGE_KEYS.RECAPTCHA_V3_FAILURE, 'false');
